import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export default function StripeCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("Connecting your Stripe account...");
  const [error,  setError]  = useState(null);

  useEffect(() => {
    const run = async () => {
      const params      = new URLSearchParams(window.location.search);
      const code        = params.get("code");
      const detailer_id = params.get("state");

      if (!code || !detailer_id) {
        setError("Invalid callback. Please try connecting again from your dashboard.");
        return;
      }

      const { data: { session: authSess } } = await supabase.auth.getSession();
      const token = authSess?.access_token;

      const res  = await fetch("/api/stripe-callback", {
        method:  "POST",
        headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body:    JSON.stringify({ code, state: detailer_id }),
      });
      const data = await res.json();

      if (!res.ok || data.error) {
        setError(data.error || "Something went wrong. Please try again.");
        return;
      }

      setStatus("Stripe connected! Redirecting to your dashboard...");
      setTimeout(() => navigate("/dashboard"), 1500);
    };
    run();
  }, [navigate]);

  return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#080b10" }}>
      <div style={{ textAlign:"center", padding:40 }}>
        {error ? (
          <>
            <div style={{ fontSize:48, marginBottom:20 }}>❌</div>
            <h2 style={{ fontFamily:"var(--head)", fontSize:28, fontWeight:800, letterSpacing:2, marginBottom:12 }}>CONNECTION FAILED</h2>
            <p style={{ color:"var(--muted)", marginBottom:24 }}>{error}</p>
            <button className="btn-primary" onClick={() => navigate("/dashboard")}>Back to Dashboard</button>
          </>
        ) : (
          <>
            <div className="spinner" style={{ width:40, height:40, border:"3px solid rgba(59,130,246,.2)", borderTopColor:"var(--blue)", margin:"0 auto 24px" }} />
            <p style={{ color:"var(--muted)", fontSize:16 }}>{status}</p>
          </>
        )}
      </div>
    </div>
  );
}
